import { render, staticRenderFns } from "./ShowMappings.vue?vue&type=template&id=f22d436c"
import script from "./ShowMappings.vue?vue&type=script&lang=js"
export * from "./ShowMappings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports